import { z } from 'zod';

import { documentDataSchemaOptional } from '@/features/ui/DocumentsData/model/schemas';
import { confirmationOfApplicationSchema } from '@/features/ui/Steps/ConfirmationOfApplication/model/schemas';
import { personalAndPassportDataBaseSchema } from '@/features/ui/Steps/PersonalAndPassportData';

import { zodPlaceholder, zodSelectOptionWithCode, zodStringOptional } from '@/shared/lib/validations';
import { addressBlockSchema } from '@/shared/ui/AddressBlock/model';

import { applicantAncestralDocumentsSchemaRequired } from '@/modules/rmp/shared/model/schemas';

export const reapplicationAddressBaseSchema = z.object({
  residenceAddress: zodPlaceholder,
  registeredAddress: addressBlockSchema,
  addressEqual: zodPlaceholder,
  residenceDocument: zodPlaceholder,
  registeredDocument: zodSelectOptionWithCode,
  documents: zodPlaceholder,
  residenceDocumentFile: zodPlaceholder,
  registeredDocumentFile: applicantAncestralDocumentsSchemaRequired,
});

export const reapplicationDocumentsSchema = z.object({
  reapplicationDocuments: documentDataSchemaOptional.nullish(),
  additional_info: zodStringOptional,
});

export const reapplicationMergedSchema = confirmationOfApplicationSchema
  .merge(personalAndPassportDataBaseSchema)
  .merge(reapplicationDocumentsSchema)
  .merge(reapplicationAddressBaseSchema);
